export default {"src":"/_next/static/media/carDamage_40.1130f730.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};